import { getOrder } from 'redux/modules/order/selectors';

export default state => {
  const orderState = getOrder(state);
  const customerOrderId = orderState?.customerOrderId;
  return { id: customerOrderId };
};
